import React from 'react';
import { CopyCard, CopyField, setStoreCopy } from './adminSiteCopyFields';
import AdminSiteImageField from './AdminSiteImageField';
import AdminBespokeFormOptionsEditor from './AdminBespokeFormOptionsEditor';
import { mergeCustomJewelryConfig } from '../content/siteCopyHelpers';
import {
  BESPOKE_JEWELRY_TYPE_DEFAULTS,
  BESPOKE_OCCASION_DEFAULTS,
} from '../jewelry/bespokeFormOptionDefaults';function ToggleRow({ id, label, hint, checked, onChange }) {
  return (
    <div className="col-12">
      <div className="form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          id={id}
          role="switch"
          checked={Boolean(checked)}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label className="form-check-label" htmlFor={id}>
          {label}
        </label>
        {hint ? <p className="small text-muted mb-0 mt-1">{hint}</p> : null}
      </div>
    </div>
  );
}

export default function AdminSiteCustomJewelryFields({ form, setField, sessionToken, onPersistCustomJewelryHero }) {
  const store = form.store_copy || {};
  const cj = mergeCustomJewelryConfig(store.custom_jewelry);
  const setCustomJewelry = (patch) => {
    setStoreCopy(form, setField, {
      custom_jewelry: { ...cj, ...patch },
    });
  };

  return (
    <>
      <CopyCard
        title="Custom jewelry design"
        subtitle="/custom-jewelry — bespoke haldi, mehendi & wedding enquiries"
      >
        <ToggleRow
          id="cj-enabled"
          label="Enable custom jewelry page"
          hint="When off, hide links and the admin bespoke inbox still works for past requests."
          checked={cj.enabled}
          onChange={(v) => setCustomJewelry({ enabled: v })}
        />
        <ToggleRow
          id="cj-shop"
          label="Show on shop page (button + promo card)"
          checked={cj.show_on_shop}
          onChange={(v) => setCustomJewelry({ show_on_shop: v })}
        />
        <ToggleRow
          id="cj-nav"
          label="Show in Shop menu (header)"
          checked={cj.show_in_nav}
          onChange={(v) => setCustomJewelry({ show_in_nav: v })}
        />
        <ToggleRow
          id="cj-footer"
          label="Show in footer"
          checked={cj.show_in_footer}
          onChange={(v) => setCustomJewelry({ show_in_footer: v })}
        />
        <ToggleRow
          id="cj-gf"
          label="Show promo on gift finder results"
          checked={cj.show_on_gift_finder}
          onChange={(v) => setCustomJewelry({ show_on_gift_finder: v })}
        />
      </CopyCard>

      <CopyCard title="Custom jewelry — links & shop card" subtitle="Buttons and /shop promo card">
        <CopyField
          id="cj-nav-label"
          label="Menu / footer link text"
          value={cj.nav_label || ''}
          onChange={(v) => setCustomJewelry({ nav_label: v })}
        />
        <CopyField
          id="cj-shop-label"
          label="Shop hero button"
          value={cj.shop_button_label || ''}
          onChange={(v) => setCustomJewelry({ shop_button_label: v })}
        />
        <CopyField
          id="cj-card-eyebrow"
          label="Shop card eyebrow"
          value={cj.card_eyebrow || ''}
          onChange={(v) => setCustomJewelry({ card_eyebrow: v })}
        />
        <CopyField
          id="cj-card-title"
          label="Shop card title"
          value={cj.card_title || ''}
          onChange={(v) => setCustomJewelry({ card_title: v })}
        />
        <CopyField
          id="cj-card-lead"
          label="Shop card description"
          value={cj.card_lead || ''}
          onChange={(v) => setCustomJewelry({ card_lead: v })}
          multiline={2}
        />
        <CopyField
          id="cj-card-cta"
          label="Shop card link text"
          value={cj.card_cta || ''}
          onChange={(v) => setCustomJewelry({ card_cta: v })}
        />
      </CopyCard>

      <CopyCard title="Custom jewelry — page content" subtitle="/custom-jewelry hero and form intro">
        <CopyField
          id="cj-hero-eyebrow"
          label="Page eyebrow"
          value={cj.hero_eyebrow || ''}
          onChange={(v) => setCustomJewelry({ hero_eyebrow: v })}
        />
        <CopyField
          id="cj-hero-title"
          label="Page headline"
          value={cj.hero_title || ''}
          onChange={(v) => setCustomJewelry({ hero_title: v })}
        />
        <CopyField
          id="cj-hero-lead"
          label="Page lead paragraph"
          value={cj.hero_lead || ''}
          onChange={(v) => setCustomJewelry({ hero_lead: v })}
          multiline={3}
        />
        <AdminSiteImageField
          id="cj-hero-image"
          label="Hero photo (optional)"
          value={cj.hero_image || ''}
          onChange={(v) => setCustomJewelry({ hero_image: v })}
          sessionToken={sessionToken}
          aspect="4 / 5"
          onPersist={onPersistCustomJewelryHero}
          hint="Shown beside the custom jewelry form. Upload or pick from catalog — saves automatically."
        />
        <CopyField
          id="cj-seo-title"
          label="SEO title"
          value={cj.seo_title || ''}
          onChange={(v) => setCustomJewelry({ seo_title: v })}
        />
        <CopyField
          id="cj-seo-desc"
          label="SEO description"
          value={cj.seo_description || ''}
          onChange={(v) => setCustomJewelry({ seo_description: v })}
          multiline={2}
        />
      </CopyCard>

      <AdminBespokeFormOptionsEditor
        title="Form — Occasion buttons"
        subtitle="Your event section on /custom-jewelry — single choice"
        idPrefix="cj-occasion"
        options={cj.occasions}
        defaults={BESPOKE_OCCASION_DEFAULTS}
        onChange={(occasions) => setCustomJewelry({ occasions })}
      />

      <AdminBespokeFormOptionsEditor
        title="Form — Jewelry type buttons"
        subtitle="Your event section — customer can pick multiple"
        idPrefix="cj-jtype"
        options={cj.jewelry_types}
        defaults={BESPOKE_JEWELRY_TYPE_DEFAULTS}
        onChange={(jewelry_types) => setCustomJewelry({ jewelry_types })}
      />

      <CopyCard title="Gift finder → custom jewelry promo" subtitle="Banner on /gift-finder results">        <CopyField
          id="cj-gf-title"
          label="Promo title"
          value={cj.gift_finder_promo_title || ''}
          onChange={(v) => setCustomJewelry({ gift_finder_promo_title: v })}
        />
        <CopyField
          id="cj-gf-lead"
          label="Promo description"
          value={cj.gift_finder_promo_lead || ''}
          onChange={(v) => setCustomJewelry({ gift_finder_promo_lead: v })}
          multiline={2}
        />
        <CopyField
          id="cj-gf-cta"
          label="Promo button text"
          value={cj.gift_finder_promo_cta || ''}
          onChange={(v) => setCustomJewelry({ gift_finder_promo_cta: v })}
        />
      </CopyCard>
    </>
  );
}
